import { render } from "./ApartmentSelectionList.vue?vue&type=template&id=4fcb6e70"
import script from "./ApartmentSelectionList.vue?vue&type=script&lang=js"
export * from "./ApartmentSelectionList.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__